<template>
  <div class="box">
    <el-backtop :right="40" :bottom="150" id="backTopBtn" />
    <div class="boxData">
      <div class="boxData_1">
        <div class="info" v-for="item in dataList" :key="item.id">
          <img :src="item.svg" class="infoImg">
          <h2 class="h2_1">{{ item.name }}</h2>
          <p v-for="er in item.child" :key="er.id" @click="childBtn(item, er.id)">{{ er.title }}</p>
        </div>
      </div>
      <div class="boxData_2">
        <div class="text">
          <p>Shine Optics Technology Company Limited&nbsp;&nbsp;Jiangxi Shinetech Precision Optical Co., Ltd.&nbsp;&nbsp;Shenzhen
            Shine Optics Technology Company Limited</p>
          <P>Add: No.13, Xihu Road, Tongqiao Street, Dazu District, Chongqing City.&nbsp;&nbsp;
            Shinetech Precision Optics, Chengdong Industrial area, Fenyi County, Xinyu city, Jiangxi Province.
            &nbsp;&nbsp;15th Floor, Block D, Building 1, Huarong Road Lianjian Industrial Park, Longhua District, Shenzhen.</P>
          <p>TEL:023-85226001 023-85226002 </p>
          <p>FAX:023-85226001 023-85226002 </p>
        </div>
        <div class="image">
          <h3>For more great content<br />please focus on Wechat public account.</h3>
          <div id="qrcode_1" ref="qrcode_1" class="qrcode_1"></div>
        </div>
      </div>
      <p class="p1">© {{new Date().getFullYear()}} Shine Optics Technology Company Limited
        <!-- <a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index"> Chongqing ICP prepared No. 2022000344-1</a> -->
      </p>
    </div>
  </div>
</template>

<script>
import { reactive, toRefs, ref, onMounted, watch, toRaw } from "vue";
import { useRouter, useRoute } from "vue-router";
import QRCode from 'qrcodejs2'
export default {
  emits: ['submitData'],

  setup(props, { emit }) {
    const route = useRouter();
    const r = useRoute()
    watch(() => route.currentRoute.value.path, (count, prevCount) => {
      // console.log(count);
      if (count == '/en/product') {
        localStorage.setItem('menuId', 1)
      } else if (count == '/en/about' || count == '/en/manufacture' || count == '/en/aboutId' || count == '/en/aboutImg' || count == '/en/quality' || count == '/en/research') {
        localStorage.setItem('menuId', 2)
      } else if (count == '/en/news' || count == '/en/news') {
        localStorage.setItem('menuId', 3)
      } else if (count == '/en/cooperation' || count == '/en/business_partner' || count == '/en/commercial_ethics' || count == '/en/social_responsibility' || count == '/en/develop') {
        localStorage.setItem('menuId', 4)
      } else if (count == '/en/join' || count == '/en/joinId' || count == '/en/idea') {
        localStorage.setItem('menuId', 5)
      } else if (count == '/en/contactus') {
        localStorage.setItem('menuId', 6)
      }
    }, { immediate: true })
    const state = reactive({
      dataList: [
        { id: 1, svg: require('@/assets/foot/产品中心.svg'), name: 'Products Center', child: [{ id: 5, title: 'Mobile Termination' }, { id: 4, title: 'Notebook' }, { id: 3, title: 'AIoT' }, { id: 2, title: 'Car & Medical' }, { id: 1, title: "LED" }] },
        { id: 5, svg: require('@/assets/foot/加入盛泰.svg'), name: 'Join Us', child: [{ id: 1, title: 'Career Opportunities' }, { id: 2, title: 'Talent Concept' }] },
        { id: 3, svg: require('@/assets/foot/新闻活动.svg'), name: 'Shinetech News', child: [{ id: 1, title: 'News' }, { id: 2, title: 'Events' }] },
        { id: 2, svg: require('@/assets/foot/盛泰制造.svg'), name: 'About Us', child: [{ id: 1, title: 'R&D' }, { id: 2, title: 'Quality' }, { id: 3, title: 'Production Environment' }] },
      ]
    })
    let methods = {
      qrCode() {
        let qrcode_1 = new QRCode('qrcode_1', {
          width: 100,
          height: 100,
          text: 'https://www.shine-optics.com/en', // 二维码地址
          colorDark: "#000",
          colorLight: "#fff",
        })
      },
      childBtn(item, id) {
        // console.log(item);
        localStorage.setItem('menuId', item.id)
        document.getElementById('backTopBtn').click()
        switch (item.id) {
          case 1:
            route.push('/en/product')
            localStorage.setItem('id', id)
            emit('submitData', id)
            break;
          case 2:
            // console.log(item);
            if (id == 3) {
              localStorage.setItem('emp_id', 1)
              route.push({ path: '/en/manufacture' })

            } else if (id == 2) {
              route.push('/en/quality')

            } else if (id == 1) {
              route.push('/en/research')

            }
            break;
          case 3:
            route.push("/en/news");
            break;
          case 5:
            if (id == 1) {
              route.push('/en/joinId')
            } else if (id == 2) {
              route.push('/en/idea')
            }
            break;

          default:
        }
        // window.scrollTo(0, 0);

      }
    }
    onMounted(() => {
      // console.log('route',route.currentRoute._rawValue.path);
      methods.qrCode()
      let svg = document.getElementsByClassName('infoImg')
      for (let i = 0; i < svg.length; i++) {
        if (i > 1) {
          console.log(svg[i]);
          svg[i].style.left = '3.625rem'
        }

      }
    })
    return {
      ...toRefs(state),
      ...methods
    };
  },
};
</script>

<style scoped lang="less">
.h2_1 {
  font-size: 18px;
}

.p1 {
  text-align: center;
  color: black;
  font-size: 14px;
  min-height: 30px;
  height: auto;
  line-height: 30px;
  background-color: #E6E6E6;

  margin: 0;
  padding: 0;

  a {
    cursor: pointer;
    color: black;
    text-decoration: none;
  }
}

.box {
  margin-top: 50px;
  width: 100%;
  min-height: 500px;
  background-color: #E6E6E6;
  overflow: hidden;

  .boxData {
    height: 100%;
    width: 80%;
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    max-width: 1920px;

    .boxData_1,
    .boxData_2 {
      flex: 1;
    }

    .boxData_1 {
      display: flex;
    }

    .boxData_2 {
      display: flex;

      .text {
        border-top: 1px solid black;
        flex: 3;
        color: black;
        padding: 30px 32px 0 50px;
        box-sizing: border-box;
      }

      .image {
        text-align: center;
        flex: 1;
        margin-left: 50px;

      }
    }
  }
}

.info {
  width: 100%;
  position: relative;
  text-align: center;
  min-width: 270px;

  h2 {

    margin-top: 40px;
    flex-wrap: wrap;
    margin-left: -22px;
  }

  p {
    margin-left: -30px;
    font-weight: 400;
    cursor: pointer;
    // transition: all 0.3s;
  }

  p:hover {
    color: red;
  }

  img {
    position: absolute;
    top: 30px;
    left: 3.5rem;
    width: 40px;
    height: 40px;
  }

}

.qrcode_1 {
  margin-left: 50%;
  transform: translateX(-25%);
}
</style>